<template>
  <!-- Element Plus version -->
  <el-dropdown 
    v-if="useMenu && !useVuetify"
    trigger="click" 
    @command="toggleValue"
    :size="size"
    ref="menudrop"
  >
    <span class="el-dropdown-link"></span>
    <template #dropdown>
      <el-dropdown-menu v-model="selectedId" slot="dropdown">
        <el-dropdown-item
          v-for="block in blocks"
          :key="block.id"
          :command="block.id"
        >{{block.label}}</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>

  <el-select
    v-if="!useMenu && !useVuetify"
    v-model="selectedId"
    :placeholder="placeHolder"
    :size="size"
    :clearable="clearable"
    @change="toggleValue(selectedId)"
  >
    <el-option
      v-for="block in blocks"
      v-bind:key="block.id"
      :value="block.id"
      :label="block.label"
    ></el-option>
  </el-select>

  <!-- Vuetify version -->
  <v-menu
    v-if="useMenu && useVuetify"
    v-model="menuOpen"
    :close-on-content-click="true"
    location="bottom"
  >
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        :size="size === 'small' ? 'small' : 'default'"
        variant="text"
        icon
      >
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list density="compact">
      <v-list-item
        v-for="block in blocks"
        :key="block.id"
        :value="block.id"
        @click="toggleValue(block.id)"
      >
        <v-list-item-title>{{ block.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>

  <v-select
    v-if="!useMenu && useVuetify"
    v-model="selectedId"
    :items="blocks"
    item-value="id"
    item-title="label"
    :placeholder="placeHolder"
    :density="size === 'small' ? 'compact' : 'default'"
    variant="outlined"
    hide-details
    :clearable="clearable"
    @update:model-value="toggleValue"
  ></v-select>
</template>


<script setup>
  import { reactive, computed, ref, watch, onMounted } from 'vue';
  import { useStore } from 'vuex';

  const name = 'contentBlockSelect';
  const store = useStore();

  const emit = defineEmits(['update:modelValue', 'update', 'updateContent']);

  // Data
  // import type { DropdownInstance } from 'element-plus'
  const menudrop = ref(null);
  const menuOpen = ref(false);
  const blocks = ref([]);
  const value = ref();
  const selectedId = ref(0);

  // Computed
  const getHtmlBlocks = computed(() => {
    return store.getters['contentBlocks/getHtmlBlocks'];
  });
  const getTextBlocks = computed(() => {
    return store.getters['contentBlocks/getTextBlocks'];
  });

  const props = defineProps({
      modelValue: {
          type: [Number, String],
          required: false,
          default: () => { return 0 },
      },
      replyType: {
          type: String,
          required: true,
      },
      useMenu: {
          type: Boolean,
          required: false,
          default: () => { return false },
      },
      size: {
          type: String,
          required: false,
          default: () => { return 'small' },
      },
      placeHolder: {
          type: String,
          required: false,
          default: () => { return 'Quick Reply' },
      },
      useVuetify: {
          type: Boolean,
          required: false,
          default: () => { return false },
      },
      clearable: {
          type: Boolean,
          required: false,
          default: () => { return false },
      },
  });

  // const menuDrop = ref<DropdownInstance>();
  function toggleValue(id) {
    const block = blocks.value.find(b => b.id == id);
    if (!block) {
      // cleared (or unknown id) - reset the selection without wiping content
      selectedId.value = null;
      emit('update:modelValue', null);
      emit('update', null);
      return;
    }
    emit('update:modelValue', block.id);
    emit('update', block.id);
    emit('updateContent', block.content);
  };

  watch(value, (n) => {
    selectedId.value = n;
  });
  watch(() => props.modelValue, (n) => {
    selectedId.value = n;
  });
  // Created

  onMounted(() => {
    if (props.modelValue) {
      selectedId.value = props.modelValue;
    }
    if (props.replyType == 'html') {
      blocks.value = getHtmlBlocks.value;
    }
    else if (props.replyType == 'text') {
      blocks.value = getTextBlocks.value;
    }
    else {
      console.error('Invalid content block type declared', props.replyType);
    }
    if (props.useMenu && !props.useVuetify) {
      menudrop.value?.handleOpen();
    }
    if (props.useMenu && props.useVuetify) {
      menuOpen.value = true;
    }
  })
</script>
